import { render, staticRenderFns } from "./GridRdia.vue?vue&type=template&id=67afe238&scoped=true&"
import script from "./GridRdia.vue?vue&type=script&lang=ts&"
export * from "./GridRdia.vue?vue&type=script&lang=ts&"
import style0 from "./GridRdia.vue?vue&type=style&index=0&id=67afe238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67afe238",
  null
  
)

export default component.exports